import * as React from "react";

import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";
import {WithStyles} from "@material-ui/core/styles/withStyles";

import {Container, Text} from "../components";

import Activity from "./Activity";
import Banner from "./Banner";
import CoffeeCheckout from "./CoffeeCheckout";
import CoffeeIcon from "./CoffeeIcon";

type ClassNames = "link" | "intro" | "columns" | "leftColumn" | "rightColumn";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
  link: {
    color: theme.typography.body1.color
  },
  intro: {
    padding: theme.spacing.unit * 2,
    [theme.breakpoints.down("xs")]: {
      textAlign: "justify"
    }
  },
  columns: {
    display: "flex",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column"
    }
  },
  leftColumn: {
    padding: theme.spacing.unit * 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    flex: 0.61,
    [theme.breakpoints.down("md")]: {
      flex: 1
    }
  },
  rightColumn: {
    padding: theme.spacing.unit * 2,
    flex: 0.39,
    [theme.breakpoints.down("md")]: {
      flex: 1
    }
  }
});

interface IBuyMeACoffeeProps extends WithStyles<typeof styles>  {}

class BuyMeACoffee extends React.PureComponent<IBuyMeACoffeeProps> {

  public render() {
    const {classes} = this.props;
    return (
      <>
        <Banner />
        <Container>
          <Text align="justify" className={classes.intro}>
            I'm William, maker of
            the <a href="https://www.youtube.com/user/wcandill" className={classes.link}>“Can it be done in React Native?”</a> YouTube series.
            In each episode, we explore an iconic user experience from an app that people know and love: Instagram, Tinder, Snapchat and so on.
            A GitHub repository with a working example on both iOS and Android as well as the demo running on expo snacks is always provided.
            If you like the series, you can buy me a coffee and receive content before it's released to the public. I'll also make sure to treat your requests in priority.
          </Text>
          <div className={classes.columns}>
            <div className={classes.leftColumn}>
              <CoffeeIcon />
            </div>
            <div className={classes.rightColumn}>
              <CoffeeCheckout />
            </div>
          </div>
          <Activity />
        </Container>
      </>
    );
  }
}

export default withStyles(styles)(BuyMeACoffee);



// WEBPACK FOOTER //
// ./src/buy-me-a-coffee/BuyMeACoffee.tsx